import { memo, VFC, useState, useEffect } from 'react';
import {
  Table,Thead,Tbody,Tr,Th,Td,Box,Flex,
  Text,Center,Spinner,
  RadioGroup,Radio,Stack,
} from '@chakra-ui/react';
import { customerObj } from '../../types/issue';
import { useLoginUser } from "../../hooks/providers/useLoginUserProvider";

type Props = {
  executing: boolean;
  custList1: customerObj[];
  custList2: customerObj[];
  custList3: customerObj[];
  mode: string;
};

export const CustomerTable: VFC<Props> = memo((props) => {
  const { executing=true, custList1, custList2, custList3, mode} = props;
  const [ custList1Num, setCustList1Num ] = useState(0);
  const [ custList2Num, setCustList2Num ] = useState(0);
  const [ custList3Num, setCustList3Num ] = useState(0);
  const { loginUser } = useLoginUser();
  
  const [ userType ] = useState('accountList');
  const [ listType, setListType ] = useState(loginUser.userGroup === 'exec' ? 'userList' : 'accountList');
  // const [ userType, setUserType ] = useState(
  //   userGroup === 'health' || userGroup === 'support' || userGroup === 'dev' || userGroup === 'spfexecutive' ? 'accountList' : 
  //   userGroup !== 'public' ? 'userList' :
  //   userGroup === 'public' ? 'depList' : ''
  // );

  useEffect(() => {
    setCustList1Num(custList1 && custList1.length);
    setCustList2Num(custList2 && custList2.length);
    setCustList3Num(custList3 && custList3.length);
  }, [custList1,custList2,custList3]);
  
  return (
    <>
      {executing ? (
        <Center>
          <Spinner color="teal.500" />
        </Center>
      ) : ( custList1Num == 0 ? (
        <>
        <br />
          <Text fontSize="lg">本障害で影響があるお客様は特定できません。</Text>
        <br />
        </>
      ) :
        <> 
        <Box>
          <Flex>
            <Text fontSize="lg">■影響アカウント（{userType === 'accountList' ? custList1Num : userType === 'userList' ? custList2Num : custList3Num}件）</Text>
            
            { (userType === 'accountList' && loginUser.necFlag) ? (
              <>
              <Text fontSize="lg">［</Text>
                <RadioGroup onChange={setListType} value={listType}>
                  <Stack direction='row'>
                    <Radio value='accountList'>アカウント単位</Radio>
                    <Radio value='userList'>お客様単位</Radio>
                    <Radio value='depList'>組織単位</Radio>
                  </Stack>
                </RadioGroup>
              <Text fontSize="lg">］</Text>
              </>
            ) : (
              <>
              </>
            )}

            
          </Flex>
          
          { listType === 'accountList' ? (
            <Table id="table-health-group-detail" border="1" colorScheme="gray" variant="striped" size="sm">
              <Thead background="#aaaaaa">
                <Tr>
                  <Th width="10px" color="white" fontSize="sm">No.</Th>
                  {loginUser.necFlag && (
                    <>
                    <Th color="white" fontSize="sm">部署名（会社名）</Th>
                    <Th color="white" fontSize="sm">部門コード（部署名）</Th>
                    </>
                  )}
                  <Th color="white" fontSize="sm">お客様名</Th>
                  <Th color="white" fontSize="sm">アカウントID</Th>
                  {mode == "group" &&
                    <>
                    <Th color="white" fontSize="sm">障害種別</Th>
                    {loginUser.necFlag &&
                      <Th color="white" fontSize="sm">問い合わせ有無</Th>
                    }
                    </>
                  }
                </Tr>
              </Thead>
              <Tbody>
                {custList1.map((cust:customerObj,index) => (
                  <Tr key={index}>
                    <Td>{index+1}</Td>
                    {loginUser.necFlag && (
                      <>
                      <Td>{cust.prof_center}</Td>
                      <Td>{cust.sales_office}</Td>
                      </>
                    )}
                    <Td>{cust.end_user}</Td>
                    <Td>{cust.account_id}</Td>
                    {mode == "group" &&
                      <>
                      <Td>{cust.health_kind}</Td>
                      {loginUser.necFlag &&
                        <Td>{cust.case_link}</Td>
                      }
                      </>
                    }
                  </Tr>
                ))}
              </Tbody>
            </Table>
          ) : listType === 'userList' ? (
            <Table id="table-health-group-detail" border="1" colorScheme="gray" variant="striped" size="sm">
              <Thead background="#aaaaaa">
                <Tr>
                  <Th width="10px" color="white" fontSize="sm">No.</Th>
                  <Th color="white" fontSize="sm">部署名（会社名）</Th>
                  <Th color="white" fontSize="sm">部門コード（部署名）</Th>
                  <Th color="white" fontSize="sm">お客様名</Th>
                  <Th color="white" fontSize="sm">アカウント件数</Th>
                </Tr>
              </Thead>
              <Tbody>
                {custList2.map((cust:customerObj,index) => (
                  <Tr key={index+1000}>
                    <Td>{index+1}</Td>
                    <Td>{cust.prof_center}</Td>
                    <Td>{cust.sales_office}</Td>
                    <Td>{cust.end_user}</Td>
                    <Td align="right">{cust.account_cnt}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          ) : listType === 'depList' && (
            <Table id="table-health-group-detail" border="1" colorScheme="gray" variant="striped" size="sm">
              <Thead background="#aaaaaa">
                <Tr>
                  <Th width="10px" color="white" fontSize="sm">No.</Th>
                  <Th color="white" fontSize="sm">部署名（会社名）</Th>
                  <Th color="white" fontSize="sm">部門コード（部署名）</Th>
                  <Th color="white" fontSize="sm">アカウント件数</Th>
                </Tr>
              </Thead>
              <Tbody>
                {custList3.map((cust:customerObj,index) => (
                  <Tr key={index+1000}>
                    <Td>{index+1}</Td>
                    <Td>{cust.prof_center}</Td>
                    <Td>{cust.sales_office}</Td>
                    <Td align="right">{cust.account_cnt}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
            )}
        </Box>
        </>
      )}
    </>
  );
});
